import { loadArtImage } from "../../lib/schedule-art/art-assets";
import { getPlatformIcons } from "../platform-icons";

const images = new Map<string, HTMLImageElement>();

export async function loadPlatformImages() {
  const originals = Object.entries(getPlatformIcons("default"));
  const black = Object.entries(getPlatformIcons("black")).map(
    ([platform, source]) => [`${platform}:black`, source] as const,
  );
  const sources = [...originals, ...black];
  await Promise.all(
    sources.map(async ([key, source]) => {
      const image = await loadArtImage(source);
      images.set(key, image);
    }),
  );
}

export function platformImage(platform: string, blackIcon = false) {
  const key = blackIcon ? `${platform}:black` : platform;
  return images.get(key);
}
